import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Desactivar error overlay en desarrollo para evitar interrupciones con SDKs externos (PayPal)
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    // Ignorar errores de cross-origin y insertBefore (conflictos con PayPal SDK)
    if (e.message && (
      e.message.includes('cross-origin') || 
      e.message.includes('insertBefore') ||
      e.message.includes('removeEventListener')
    )) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
